<template>
  <v-snackbar
    v-model="showSnackbar"
    center
    bottom
    :timeout="-1"
    :color="snackbarColor"
  >
    {{ snackbarMessage }}

    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="$store.commit('resetNotification')">
        {{ $t("close") }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "Notification",
  data: () => ({}),
  mounted() {
    if (this.$store.state.showSnackbar) {
      this.$store.commit("resetNotification");
    }
  },
  computed: {
    showSnackbar() {
      return this.$store.getters.getShowSnackbar;
    },
    snackbarMessage() {
      return this.$store.getters.getSnackbarMessage;
    },
    snackbarColor() {
      return this.$store.getters.getSnackbarColor;
    },
  },
  watch: {
    showSnackbar(value) {
      if (value) {
        let _this = this;
        setTimeout(() => {
          _this.$store.commit("resetNotification");
        }, 5000);
      }
    },
  },
};
</script>

<style lang="css">
.black,
.default {
  background: #212121;
  font-family: "Roboto";
}
.green,
.success {
  background: #4caf50;
  font-family: "Roboto";
}
.red,
.error {
  background: #f44336;
  font-family: "Roboto";
}
.blue,
.info {
  background: #2196f3;
  font-family: "Roboto";
}
.orange,
.alert {
  background: #f57c00;
  font-family: "Roboto";
}
</style>
